import { useState } from "react";
import { Eye, EyeOff, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { vid } from "@/pages/landing/parts";
import { inputCls } from "@/pages/landing/parts";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

function errorFor(e, a, mode) {
  const s = e?.response?.status;
  const d = String(e?.response?.data?.detail || "");
  if (s === 429) return a.errLocked;
  if (mode === "login" && s === 401) return a.errLogin;
  if (d === "Email already registered") return a.errExists;
  if (d === "Invalid email") return a.errEmail;
  if (d.startsWith("Password must")) return a.errPw;
  return a.errGeneric;
}

export function SignupSheet({ open, onOpenChange, a, lang, redirect = "/" }) {
  const [mode, setMode] = useState("signup");
  const [f, setF] = useState({ first_name: "", email: "", password: "" });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const signup = mode === "signup";
  const set = (k) => (e) => { setF({ ...f, [k]: e.target.value }); setErr(""); };
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    const email = f.email.trim();
    const bad = signup && f.first_name.trim().length < 1 ? a.errName : !EMAIL_RE.test(email) ? a.errEmail : signup && f.password.length < 8 ? a.errPw : !f.password ? a.errPw : "";
    if (bad) { setErr(bad); return; }
    setBusy(true);
    try {
      const { data } = signup
        ? await api.post("/auth/register", { first_name: f.first_name.trim(), email, password: f.password, language: lang, visitor_id: vid() })
        : await api.post("/auth/login", { email, password: f.password });
      localStorage.setItem("sb_token", data.token);
      window.location.replace(redirect);
    } catch (er) {
      const m = errorFor(er, a, mode);
      setErr(m);
      if (m === a.errExists) setMode("login");
      setBusy(false);
    }
  };
  const switchMode = () => { setMode(signup ? "login" : "signup"); setErr(""); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="w-[94vw] max-w-[420px] rounded-3xl bg-white p-6 gap-0" data-testid="free-signup-sheet">
        <DialogTitle className="font-display font-extrabold text-2xl text-[#102B3F] leading-tight" data-testid="free-signup-title">{signup ? a.signupT : a.loginT}</DialogTitle>
        <DialogDescription className="text-[15px] text-[#4A5D6A] mt-1">{signup ? a.signupS : a.loginS}</DialogDescription>
        <form onSubmit={submit} noValidate className="mt-5 space-y-3" data-testid="free-signup-form">
          {signup && <input autoComplete="given-name" placeholder={a.first} value={f.first_name} onChange={set("first_name")} className={inputCls} data-testid="free-signup-first-name" />}
          <input type="email" inputMode="email" autoComplete="email" placeholder={a.email} value={f.email} onChange={set("email")} className={inputCls} data-testid="free-signup-email" />
          <div className="relative">
            <input type={show ? "text" : "password"} autoComplete={signup ? "new-password" : "current-password"} placeholder={signup ? a.password : a.passwordLogin} value={f.password} onChange={set("password")} className={`${inputCls} pr-12`} data-testid="free-signup-password" />
            <button type="button" onClick={() => setShow(!show)} aria-label={show ? a.hide : a.show} className="absolute right-1 top-1 h-10 w-10 flex items-center justify-center text-[#5C6B73]" data-testid="free-signup-toggle-password">{show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}</button>
          </div>
          {err && <p role="alert" className="text-sm font-semibold text-rose-600" data-testid="free-signup-error">{err}</p>}
          <button disabled={busy} className="lp-btn w-full min-h-[54px] text-[16px]" data-testid="free-signup-submit">{busy ? a.wait : signup ? a.signupBtn : a.loginBtn} <ArrowRight className="h-4 w-4" /></button>
          {signup && <p className="text-xs text-center text-[#7D8C96]">{a.terms}</p>}
        </form>
        <div className="mt-4 text-sm text-center text-[#5C6B73]">{signup ? a.haveAcc : a.noAcc} <button onClick={switchMode} className="font-bold text-[#088F7E] min-h-[44px] px-1" data-testid="free-signup-switch">{signup ? a.login : a.signup}</button></div>
      </DialogContent>
    </Dialog>
  );
}
